import { Routes } from '@angular/router';

import { authGuard, adminGuard } from './core/auth/auth.guard';

import { HomeComponent } from './features/home/home.component';
import { InventoryComponent } from './features/inventory/inventory.component';
import { LoginComponent } from './core/auth/pages/login/login.component';
import { CategoryListComponent } from './features/category-list/category-list.component';
import { ProductListComponent } from './features/product-list/product-list.component';
import { RollListComponent } from './features/roll-list/roll-list.component';
import { ShoppingCartComponent } from './features/shopping-cart/shopping-cart.component';
import { SupplierListComponent } from './features/supplier-list/supplier-list.component';
import { UserListComponent } from './features/user-list/user-list.component';
// import { SaleListComponent } from './features/sale-list/sale-list.component';
import { WarehouseListComponent } from './features/warehouse-list/warehouse-list.component';

export const routes: Routes = [
  {
    path: 'inicio-sesion',
    component: LoginComponent,
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'inventario',
        pathMatch: 'full',
      },
      {
        path: 'inventario',
        component: InventoryComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'categorias',
        component: CategoryListComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'proveedores',
        component: SupplierListComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'productos',
        component: ProductListComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'rollos',
        component: RollListComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'usuarios',
        component: UserListComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'almacenes',
        component: WarehouseListComponent,
        canActivate: [adminGuard],
      },
      // {
      //   path: 'ventas',
      //   component: SaleListComponent,
      //   canActivate: [adminGuard],
      // },
      {
        path: 'carrito',
        component: ShoppingCartComponent,
      },
    ],
  },
];
